/* eslint-disable global-require */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { isSubscriptionJourney, isOneShop } from '../../helpers'
import { getBrandName } from '../brand'
import { getPrivacyPolicy } from '../../helpers'

import { continueLaterLocalization } from '@vwfs-its/sf-sac-frontend'

interface InitI18nFunction {
  // eslint-disable-next-line no-unused-vars
  (brandName: string, product?: string): Promise<void>
}

i18n
  .use(initReactI18next)
  .init({
    resources: {},
    lng: process.env.REACT_APP_COUNTRYCODE,
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
  })

const initI18n: InitI18nFunction = (brandName: string) => {
  return new Promise(resolve => {
    const namespaces = [
      'chi',
      'clave',
      'clave-upload',
      'lead-generation',
      'form',
      'data',
      'contact',
      'completion',
      'validation',
      'footer',
      'header',
      'error',
      'cookie',
      'offer',
      'upload',
      'upload-additional',
      'link-expired',
      'dac-selection',
      'dac',
      'dacInstantor',
      'spinner',
      'stepper',
      'S&C',
    ]
    Promise.all(
      namespaces.map(item => {
        return import(`../../resources/base/content/${item}.json`)
          .then(module => {
            i18n.addResourceBundle(
              process.env.REACT_APP_COUNTRYCODE as string,
              item,
              module.default,
              true,
              true
            )
          })
          .then(() => {
            let brandWithProduct = brandName
            if (isSubscriptionJourney()) {
              brandWithProduct = `${brandName}-subscription`
            } else if (isOneShop()) {
              brandWithProduct = `${brandName}-oneshop`
            }

            import(`../../resources/${brandWithProduct}/content/${item}.json`)
              .then(module => {
                i18n.addResourceBundle(
                  process.env.REACT_APP_COUNTRYCODE as string,
                  item,
                  module.default,
                  true,
                  true
                )
              })
              .catch(() => {})
          })
      })
    )
      .then(() => {
        const localization = continueLaterLocalization({
          locale: 'es',
          brandName: getBrandName(),
          dataProtectionLink: getPrivacyPolicy(),
        })
        i18n.addResourceBundle('es', 'sf-sac', localization, true, true)
      })
      .then(() => resolve())
  })
}

export default initI18n
